/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */
export { parseContentAction } from '@/data/utils/parseContentAction';
